class StickyBackTop extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  constructor() {
    super();
    this.stickyContainer = this.querySelector('.sticky-back-top__wrapper');
    const handleIntersection = (entries) => {
      entries.forEach(({isIntersecting}) => this.update(isIntersecting));
    };

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 10px 0px'}).observe(this);
  }

  update(inView) {
    this.isIntersecting = inView;

    if (inView) {
      this.stickyContainer?.classList.remove('active');
    } else {
      this.stickyContainer.classList.add('active');
    }
  }
}

customElements.define('sticky-back-top', StickyBackTop);
